import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "ds-avatar ds-avatar--appearance_rounded ds-avatar--size_custom-xs" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "ds-avatar__label"
}
const _hoisted_5 = { class: "qin-userbar__name" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "qin-userbar__content"
}
const _hoisted_8 = { class: "qin-userbar__menu" }
const _hoisted_9 = { class: "qin-userbar__menu-element" }
const _hoisted_10 = { class: "qin-userbar__icon-wrapper" }
const _hoisted_11 = { class: "qin-userbar__icon" }
const _hoisted_12 = { class: "qin-userbar__text" }
const _hoisted_13 = { class: "qin-userbar__menu-element" }
const _hoisted_14 = { class: "qin-userbar__icon-wrapper" }
const _hoisted_15 = { class: "qin-userbar__icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ui_click_outside = _resolveComponent("ui-click-outside")!
  const _component_sidebar_trigger = _resolveComponent("sidebar-trigger")!

  return (_openBlock(), _createBlock(_component_sidebar_trigger, { "input-ref": _ctx.$emit }, {
    default: _withCtx(({ sidebarIsOpen, sidebarToggle, sidebarClose }) => [
      _createVNode(_component_ui_click_outside, { do: sidebarClose }, {
        default: _withCtx(({ ref }) => [
          _createElementVNode("div", {
            class: "userbar-click-wrapper",
            ref: ref
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: "qin-userbar",
                onClick: _withModifiers(sidebarToggle, ["prevent"])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["qin-userbar__avatar", {'is-active': sidebarIsOpen}])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    ($setup.profile.avatar && $setup.profile.avatar.length)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "ds-avatar__image",
                          src: $setup.profile.avatar
                        }, null, 8, _hoisted_3))
                      : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.profile.firstName? $setup.profile.firstName[0] : '?'), 1))
                  ])
                ], 2),
                _createElementVNode("p", _hoisted_5, _toDisplayString($setup.isAdmin ? `${$setup.profile.firstName} ${$setup.profile.lastName}` : $setup.profile.organizationName), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["qin-userbar__arrow", {'is-active': sidebarIsOpen}])
                }, [
                  _createElementVNode("img", { src: '/static/app/arrow-down.svg' }, null, 8, _hoisted_6)
                ], 2),
                _createVNode(_Transition, { name: "fade" }, {
                  default: _withCtx(() => [
                    sidebarIsOpen
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_router_link, {
                              class: "ds-link ds-link--userbar",
                              to: {name: $setup.PROFILE_PAGE_NAME}
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                      (_openBlock(), _createBlock(_resolveDynamicComponent('i-side-profile'), { class: "button_img" }))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("span", null, _toDisplayString($setup.$t('Personal cabinet')), 1)
                                  ])
                                ])
                              ]),
                              _: 1
                            }, 8, ["to"]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                  (_openBlock(), _createBlock(_resolveDynamicComponent('i-logout'), { class: "button_img" }))
                                ])
                              ]),
                              _createElementVNode("div", {
                                class: "qin-userbar__text",
                                onClick: _withModifiers($setup.logout, ["prevent"])
                              }, [
                                _createElementVNode("span", null, _toDisplayString($setup.$t('Log Out')), 1)
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024)
              ], 8, _hoisted_1)
            ])
          ], 512)
        ]),
        _: 2
      }, 1032, ["do"])
    ]),
    _: 1
  }, 8, ["input-ref"]))
}